export class ChangeShowCallInfo {
   public static readonly type = '[StageSettings] Change Show Call Info';

   constructor(public brickInstanceId, public showCallInfo: boolean) {}
}

export class ChangeShowHistory {
   public static readonly type = '[StageSettings] Change Show History';

   constructor(public brickInstanceId, public showHistory: boolean) {}
}

export class ChangeShowNextDialTarget {
   public static readonly type = '[StageSettings] Change Show Next Dial Target';

   constructor(public brickInstanceId, public showNextDialTarget: boolean) {}
}

export class ChangeShowDefaultBackground {
   public static readonly type = '[StageSettings] Change Show Default Background';

   constructor(public brickInstanceId, public showDefaultBackground: boolean) {}
}
